import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VDialog, {
    style: {
      zIndex: _vm.options.zIndex
    },
    attrs: {
      persistent: "",
      "max-width": _vm.options.width
    },
    on: {
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
        return _vm.close.apply(null, arguments);
      }
    },
    model: {
      value: _vm.isShown,
      callback: function callback($$v) {
        _vm.isShown = $$v;
      },
      expression: "isShown"
    }
  }, [_c(VCard, [_c("div", {
    staticClass: "dialog-closer"
  }, [_c(VIcon, {
    staticClass: "far fa-times-circle",
    attrs: {
      disabled: _vm.isValidating
    },
    on: {
      click: _vm.close
    }
  })], 1), _c(VCardTitle, {
    staticClass: "pb-0"
  }, [_c("span", {
    staticClass: "text-h5"
  }, [_vm._v(" " + _vm._s(_vm.isAdding ? "New financing option" : "Edit financing option") + " ")])]), _c("section", {
    staticClass: "content"
  }, [_c(VForm, {
    model: {
      value: _vm.form.valid,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "valid", $$v);
      },
      expression: "form.valid"
    }
  }, [_c("div", [_c(VTextField, {
    staticClass: "required",
    attrs: {
      label: "Name in platform",
      placeholder: "Name",
      rules: [_vm.formRules.mustNotBeEmpty],
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.name,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  })], 1), _c("div", {
    staticClass: "mt-4"
  }, [_c(VTextField, {
    staticClass: "required",
    attrs: {
      label: "Days of delay allowed for payment",
      type: "number",
      placeholder: "Number of days",
      rules: [_vm.formRules.mustNotBeEmpty],
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.daysOfDelayAllowed,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "daysOfDelayAllowed", $$v);
      },
      expression: "form.daysOfDelayAllowed"
    }
  })], 1), _c("div", {
    staticClass: "mt-4"
  }, [_c(VAutocomplete, {
    attrs: {
      label: "Overwrite due date term",
      items: _vm.listTerms,
      clearable: "",
      "item-value": "id",
      "item-text": "name",
      "hide-no-data": "",
      "hide-selected": "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.termId,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "termId", $$v);
      },
      expression: "form.termId"
    }
  })], 1), _c(VAutocomplete, {
    staticClass: "required mt-4",
    attrs: {
      items: _vm.getAvailableFor,
      "hide-no-data": "",
      "hide-selected": "",
      "item-text": "name",
      "item-value": "id",
      label: "Available for",
      required: true,
      "hide-details": "auto",
      multiple: "",
      chips: "",
      "deletable-chips": ""
    },
    model: {
      value: _vm.availableFor,
      callback: function callback($$v) {
        _vm.availableFor = $$v;
      },
      expression: "availableFor"
    }
  }), _c(VAutocomplete, {
    staticClass: "required mt-4",
    attrs: {
      items: _vm.getCurrencies,
      "hide-no-data": "",
      "hide-selected": "",
      "item-text": "name",
      "item-value": "id",
      label: "Currencies",
      required: true,
      rules: [_vm.formRules.mustSelectValue],
      "hide-details": "auto",
      multiple: "",
      chips: "",
      "deletable-chips": ""
    },
    model: {
      value: _vm.form.currencies,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "currencies", $$v);
      },
      expression: "form.currencies"
    }
  }), _c("div", {
    staticClass: "mt-4"
  }, [_c(VTextarea, {
    attrs: {
      label: "Terms & Conditions (if empty, we display those of C&M)",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.terms,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "terms", $$v);
      },
      expression: "form.terms"
    }
  })], 1)], 1)], 1), _c(VCardActions, {
    staticClass: "actions-bottom-container"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: "",
      loading: _vm.isValidating,
      disabled: _vm.isInvalid
    },
    on: {
      click: _vm.save
    }
  }, [_vm._v(" " + _vm._s(_vm.isAdding ? "Create" : "Save") + " ")])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };